export const leadsDataStyle = {
    minWidth: "60%",
    bgcolor: "background.paper",
    borderRadius: "16px",
    padding: "0.5rem",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
};
